import React from 'react';
import { Platform } from 'react-native';
import { createMaterialTopTabNavigator } from 'react-navigation-tabs';
import { NavigationTabs } from '../../ui';
import { LeaderboardHistoryScreen } from './LeaderboardHistory';
import { TrackingBodyMetricsScreen } from './TrackingBodyMetricsScreen';
import { TrackingWorkoutPerformanceScreen } from './TrackingWorkoutPerformanceScreen';
import { withInjectedProps } from './withInjectedProps';

interface ITrackingTabNavigationProps {
    trackingTileSelected: () => void;
    isLoadingWorkout: boolean;
    workoutLoadError: any;
    workoutStats: any;
    statistics: any;
    workoutStatsDateRange: any;
    userProfile: any;
    workoutSessionService: any;
    weeklyWorkoutProgress: any;
    isLoadingHealth: boolean;
    healthLoadError: any;
    scanStats: any;
    userProfileService: any;
    navigation: any;
}

const injectedProps: ITrackingTabNavigationProps = {
    trackingTileSelected: () => undefined,
    isLoadingWorkout: false,
    workoutLoadError: null,
    workoutStats: {},
    statistics: {},
    workoutStatsDateRange: {},
    userProfile: {},
    workoutSessionService: {},
    weeklyWorkoutProgress: {},
    isLoadingHealth: false,
    healthLoadError: null,
    scanStats: {},
    userProfileService: {},
    navigation: null,
};

const TrackingWorkoutPerformanceScreenWithProps = withInjectedProps(TrackingWorkoutPerformanceScreen, injectedProps);
const TrackingBodyMetricsScreenWithProps = withInjectedProps(TrackingBodyMetricsScreen, injectedProps);
const LeaderboardHistoryScreenWithProps = withInjectedProps(LeaderboardHistoryScreen, injectedProps);
const isWeb = Platform.OS === 'web';

export const TrackingTabNavigation = createMaterialTopTabNavigator({
    ChallengesTab: {
      screen: (props) => (
        <LeaderboardHistoryScreenWithProps {...props} {...props.screenProps} />
      ),
      navigationOptions: {
        tabBarLabel: 'Leaderboards',
      },
    },
    WorkoutPerformanceTab: {
        screen: (props) => (
          <TrackingWorkoutPerformanceScreenWithProps {...props} {...props.screenProps} />
        ),
        navigationOptions: {
          tabBarLabel: 'Workouts',
        },
      },
      BodyMetricsTab: {
        screen: (props) => (
          <TrackingBodyMetricsScreenWithProps {...props} {...props.screenProps} />
        ),
        navigationOptions: {
          tabBarLabel: 'Body Targets',
        },
      },
}, {
    lazy: true,
    swipeEnabled: true,
    backBehavior: 'none',
    tabBarPosition: 'top',
    tabBarComponent: (tabBarProps) => (
        <NavigationTabs {...tabBarProps} />
    ),
});
